import Headers from 'components/home/common/typography/Headers'
import Paragraphs from 'components/home/common/typography/Paragraphs'
import { ReactChild } from 'data/types/types'

const BookingConditionsItem = ({
  title,
  content,
}: {
  title: string
  content: ReactChild
}) => {
  return (
    <>
      <Headers.H3 className="mt-8 text-grey-900 leading-28">
        {title}
      </Headers.H3>

      <Paragraphs.PropertyPage Tag="div" className="text-grey-750">
        {content}
      </Paragraphs.PropertyPage>
    </>
  )
}
export default BookingConditionsItem
